// TypeScript port of MilitaryMath.java — single source of truth for raw offense computation.
// Parity-tested against the Java side in MilitaryMathParityTest.java.

/**
 * Computes raw offense points from individual unit counts and their per-unit offense values.
 *
 * Mirrors MilitaryMath.computeRawOffensePoints in shared/military/MilitaryMath.java.
 * Any change to the formula must be reflected in both files.
 *
 * @param offspecCount     offense specialist count
 * @param offspecOffPoints offense points per offense specialist (race-specific)
 * @param eliteCount       elite count
 * @param eliteOffPoints   offense points per elite (race-specific)
 * @param soldiersCount    soldier count (1 OP/unit)
 * @param horsesCount      war horse count (1 OP/unit)
 * @param prisonersCount   prisoner count (3 OP/unit)
 * @param mercenariesCount mercenary count (3 OP/unit)
 * @returns raw offense points (before OME, generals, personality modifiers)
 */
export function computeRawOffensePoints(
  offspecCount: number,
  offspecOffPoints: number,
  eliteCount: number,
  eliteOffPoints: number,
  soldiersCount: number,
  horsesCount: number,
  prisonersCount: number,
  mercenariesCount: number
): number {
  return (
    offspecCount * offspecOffPoints +
    eliteCount * eliteOffPoints +
    soldiersCount +
    horsesCount +
    prisonersCount * 3 +
    mercenariesCount * 3
  );
}
